var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2109 0.625C11.7396 0.625 12.1908 0.811849 12.5645 1.18555C12.9382 1.55924 13.125 2.01042 13.125 2.53906C13.125 2.75781 13.0885 2.96289 13.0156 3.1543C12.9518 3.3457 12.8607 3.52344 12.7422 3.6875L11.9766 4.45312L9.29688 1.77344L10.0625 1.00781C10.2266 0.889323 10.4043 0.798177 10.5957 0.734375C10.7871 0.661458 10.9922 0.625 11.2109 0.625ZM1.64062 9.42969L0.875 12.875L4.32031 12.1094L11.4023 5.02734L8.72266 2.34766L1.64062 9.42969ZM9.43359 4.97266L4.07422 10.332L3.41797 9.67578L8.77734 4.31641L9.43359 4.97266Z",
    fill: "#2D8FA5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit.4dbf96fd.svg";
export { ForwardRef as ReactComponent };